'use strict';
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dInvoice$002dNumber$0024 from "./app.data.data_point_types$package$-Invoice-Number$.js";
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumberForm$() {
  this.aLX = null;
  this.aMa = null;
  this.aM2 = null;
  this.aM3 = false;
  this.aM8 = null;
  this.aM9 = false;
  this.aLY = null;
  this.aLZ = false;
  this.aM6 = null;
  this.aM7 = false;
  this.aM4 = null;
  this.aM5 = false;
  this.aM0 = null;
  this.aM1 = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumberForm$ = this;
  this.aLX = $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dInvoice$002dNumber$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumber$();
  this.aMa = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dInvoice$002dNumber$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumber$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumberForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumberForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumberForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumberForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumberForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumberForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumberForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumberForm$.prototype = $p;
$p.eR = (function() {
  return this.aLX;
});
$p.eO = (function() {
  return this.aMa;
});
$p.b9 = (function() {
  if ((!this.aM3)) {
    this.aM2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aM3 = true;
  }
  return this.aM2;
});
$p.b3 = (function() {
  if ((!this.aM9)) {
    this.aM8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aM9 = true;
  }
  return this.aM8;
});
$p.aG = (function() {
  if ((!this.aLZ)) {
    this.aLY = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aLZ = true;
  }
  return this.aLY;
});
$p.az = (function() {
  if ((!this.aM7)) {
    this.aM6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aM7 = true;
  }
  return this.aM6;
});
$p.aY = (function() {
  if ((!this.aM5)) {
    this.aM4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aM5 = true;
  }
  return this.aM4;
});
$p.ask = (function() {
  if ((!this.aM1)) {
    this.aM0 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Invoice Number";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aM1 = true;
  }
  return this.aM0;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumberForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumberForm$, "app.data.data_point_types$package$InvoiceNumberForm$", ({
  FZ: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumberForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumberForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumberForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumberForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumberForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumberForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumberForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumberForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumberForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumberForm$ };
//# sourceMappingURL=app.data.data_point_types$package$-Invoice-Number-Form$.js.map
